import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { motion } from 'framer-motion';
import { keyframes } from '@emotion/react';

const fadeIn = keyframes`
  0% { opacity: 0; transform: translateY(10px); }
  100% { opacity: 1; transform: translateY(0); }
`;

const AnimatedLogo = ({ size = 80, showProgress = true, color = '#4890fe' }) => {
  return (
    <Box sx={{ 
      position: 'relative', 
      width: size, 
      height: size,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto'
    }}>
      {showProgress && (
        <CircularProgress
          size={size}
          thickness={2}
          sx={{ 
            position: 'absolute',
            color: color,
            zIndex: 1
          }}
        />
      )}
      
      <Box sx={{ 
        position: 'relative',
        width: size * 0.7,
        height: size * 0.7,
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <svg 
          width="100%" 
          height="100%" 
          viewBox="0 0 1053.32 1053.32" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle 
            cx="526.66" 
            cy="526.66" 
            r="526.66" 
            fill={color} 
            as={motion.circle}
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
          />
          
          {/* The "I" part */}
          <motion.path 
            d="M213.17,280.59h132.08v502.99H213.17V280.59z" 
            fill="#FFFFFF"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          />
          
          {/* The "N" part */}
          <motion.path 
            d="M665.56,269.74c45.83,0,86.4,16.89,121.68,50.66c35.28,33.78,52.92,78.41,52.92,133.89v1.81v327.49H708.08 V509.47c0-79.01-28.95-118.51-86.85-118.51c-28.36,0-52.92,6.19-73.73,18.55c-20.81,12.37-35.73,29.4-44.78,51.11v322.96H370.64 V280.59h132.08v68.75c19.3-24.72,43.87-44.17,73.73-58.35C606.31,276.83,636,269.74,665.56,269.74z" 
            fill="#FFFFFF"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          />
        </svg>
      </Box>
    </Box>
  );
};

export default AnimatedLogo; 